import { Answer } from './training-answer';
import { NameModule } from './name-module';

export class Question {
    uid: string;
    title: NameModule;
    infobooth: NameModule;
    type: string;
    graphic: string;
    answers: Array<Answer> = [];
    createdAt: number;
    image: any;
    visibility: boolean;
    explanation: NameModule;
    // maxResponses: number;

}